export const rowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '16px 0',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const iconColumnStyles = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
};

export const textColumnStyles = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const titleRowStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const badgeStyles = {
  marginLeft: '8px',
};

export const ctaStyles = {
  flexShrink: 0,
};

export const chipsRowStyles = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
};
